'use strict';

import { getCookie, setCookie } from "../utils";

// If JavaScript is enabled remove 'no-js' class and give 'js' class
jQuery('html').removeClass('no-js').addClass('js');

(function ($) {
    $('.sm-page.-embed').find('a').on('click', function (e) {
        var href = $(this).attr('href');
        if (href && href != '#') {
            e.preventDefault();
            window.open(href);
        }
    });
})(window.jQuery);

(function ($) {
    if (!$().stick_in_parent) return;

    var offsetBetweenHeaderAndSticky = 30
    var stickyOffsetTop = offsetBetweenHeaderAndSticky + $('#header').outerHeight();
    var $adminBar = $('#wpadminbar');

    if ($adminBar.length && $adminBar.css('position') === 'fixed') {
        stickyOffsetTop += $adminBar.outerHeight();
    }
    
    $('.js-sidebar-sticky-banner').each(function() {
        $(this).stick_in_parent({
            parent: $(this).closest('.js-sidebar-sticky-banner-parent'),
            offset_top: stickyOffsetTop
        });
    });
    
    if ($('.js-sticky-share').length) {
        function updateStickyShare() {
            if ($(window).width() > 1170) {
                $('.js-sticky-share').stick_in_parent({
                    parent: '.js-sticky-share-parent',
                    offset_top: stickyOffsetTop
                });
            } else {
                $('.js-sticky-share').trigger('sticky_kit:detach');
            }
        }
        
        updateStickyShare();
        
        $(window).on('resize', updateStickyShare);
    }
    
})(window.jQuery);


// Resouces Table of Contents

(function($) {
    
    $(function() {
        
        var $toc = $('.toc_widget_list li a');
        $toc.off()
        .on('click', function (e) {
            e.preventDefault();

            var $target = $($(this).attr('href'));

            if (!$target.length) return;

            if ($target.closest('.js-subscribers-only-content').length 
                && !$target.closest('.js-subscribers-only-content').is(':visible')) {
                $target = $('.js-subscribers-only-form');
            }

            if (!$target.length) return;

            setTimeout(() => {
                $('html, body').stop()
                .animate({
                    scrollTop: $target.offset().top - ($('#wpadminbar').length ? 110 : 90)
                });
            })
            
        });
        
    });
    
})(window.jQuery);


// 404

(function($) {
    
    $(function() {
        
        $('#go-back').on('click', function (e) {
            if (history && history.length > 1) {
                e.preventDefault();
                history.go(-1);
            }
        });
        
    });
    
})(window.jQuery);


// Cases slider

(function($) {
    
    $(function() {
        
        if (!$('#cases-slider').length) return;
        
        var $clientLogos = $('.sm-clients__logo.-with-slide');
        
        var casesSlider = new Swiper('#cases-slider', {
            loop: true,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
        });
        
        function isElementInView($element, fullyInView) {
            var pageTop = $(window).scrollTop();
            var pageBottom = pageTop + $(window).height();
            var elementTop = $element.offset().top;
            var elementBottom = elementTop + $element.height();
            
            if (fullyInView === true) {
                return ((pageTop < elementTop) && (pageBottom > elementBottom));
            } else {
                return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
            }
        }
        
        $clientLogos.on('click', function(e) {
            casesSlider.slideTo($(this).data('index'));
            
            if (!isElementInView($('.reviews-slider .swiper-slide-active .reviews-slider__quote'), true)) {
                $('html, body').stop()
                .animate({
                    scrollTop: $('.reviews-slider').offset().top - (window.innerWidth >= 768 ? $('#header').outerHeight() : 0)
                });
            }
        });
        
    });
    
})(window.jQuery);



// Reviews slider with custom animation

(function($) {
    
    $(function() {
        
        if (!$('.js-reviews-slider').length) return;
        
        var reviewsSlider = new Swiper('.js-reviews-slider', {
            loop: false,
            grabCursor: true,
            slidesPerView: 1,
            autoplay: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.js-reviews-slider-pagination',
                clickable: true
            },
            navigation: {
                prevEl: '.js-reviews-slider-nav-prev',
                nextEl: '.js-reviews-slider-nav-next',
                disabledClass: 'invisible',
            },
        });
        
        
    });
    
})(window.jQuery);

// Cookie consent
(function ($) {
    
    $(function () {
        
        var cookieName = "sm_cookie_consent";
        var consentOpenedClass = "opened";
        
        var $consent = $("#c-consent");
        var $detailsBtn = $('#c-consent-details-btn');
        var $details = $('#c-consent-details');
        var $accept = $('#c-consent-accept');
        
        var cookieVal = getCookie(cookieName);
        if (!cookieVal) {
            $consent.addClass(consentOpenedClass)
        }
        
        $detailsBtn.click(function(e) {
            e.preventDefault();
            $(this).text($details.is(':visible') ? 'More details' : 'Less details');
            $details.slideToggle();
        });
        
        $accept.click(function (e) {
            e.preventDefault();
            setCookie(cookieName, 1, 9999);
            close()
        });
        
        function close() {
            $consent.removeClass(consentOpenedClass)
        }
    });
    
})(window.jQuery);


// Scroll To

export function scrollToElement($scrollToEl, $focusEl, animated) {
    if (!$scrollToEl.length) return;
    
    var $page = jQuery('html, body');
    var $header = jQuery('#header');
    var $adminbar = jQuery('#wpadminbar');
    var offset = 0;

    if ($header.length) {
        offset += $header.height();
    }
    if ($adminbar.length && $adminbar.css('position') == 'fixed') {
        offset += $adminbar.height();
    }

    if (animated) {
        $page.animate({
            scrollTop: $scrollToEl.offset().top - offset
        }, 300, function () {
            if (!$focusEl || !$focusEl.length) return;
            $focusEl.focus();
        });
    } else {
        location.hash = '#' + $scrollToEl.attr('id');
    }
    
}

(function ($) {
	$(function () {
		
		$('[data-scroll-to]').on('click', function (e) {
			e.preventDefault()
			var $scrollToEl = $($(this).data('scrollTo'));
			var $focusEl = $($(this).data('scrollToCallbackFocus'));
			scrollToElement($scrollToEl, $focusEl, true);
		})

		$('#menu-app-growth-panel a, #menu-app-growth-panel-past a').on('click', function (e) {
			e.preventDefault()
			var $scrollToEl = $($(this).attr('href'));
			scrollToElement($scrollToEl, null, true);
		})

        // $('.main-menu__item').on('mousedown', function (e) {
        //     const $self = $(this);
        //     const href = $self.attr('href')

        //     if (href.startsWith('#') && href !== '#') {
		// 	    e.preventDefault()
		// 	    var $scrollToEl = $(href);
		// 	    scrollToElement($scrollToEl, null, true);
        //     }
		// })

        // $('.main-menu__item').on('click', function (e) {
        //     const $self = $(this);
        //     const href = $self.attr('href')

        //     if (href.startsWith('#') && href !== '#') {
		// 	    e.preventDefault()
        //         e.stopPropagation()
        //     }
		// })
		
	});
})(window.jQuery);

(function($) {

    $(function () {

        var $video = $(".page-template iframe[src^='https://www.youtube.com']");

        $video.each(function() {
            var $self = $(this);
            $self.data('aspectRatio', this.height / this.width)
                .removeAttr('height')
                .removeAttr('width')
        });

        function resizeVideos() {
            $video.each(function() {
                var $self = $(this);
                var $parent = $self.parent();
                var width = $parent.width();
                $self
                    .width(width)
                    .height(width * $self.data('aspectRatio'));
            });
        }

        $(window).resize(resizeVideos);

        resizeVideos();
    })

})(window.jQuery);
